export enum Entitlements {
  NQ_FAST_EDIT = 'NQ - Fees And Special Transfers - Edit',
  NQ_FAST_READ = 'NQ - Fees And Special Transfers - Read Only'
}
